export default __webpack_public_path__ + "static/media/yt.a5de7f99.svg";